import { installVeeValidate } from './utils/veeValidate';
import * as elementPlugins from './js/elements';
import * as patternPlugins from './js/patterns';
import { vueUse } from './utils/plugins';
import config, { setOptions } from './utils/config';

export function install(Vue, options = {}) {
  if (install.installed) return;
  install.installed = true;

  setOptions(Object.assign(config, options));

  // Register element plugins
  Object.keys(elementPlugins).forEach((plugin) => {
    Vue.use(elementPlugins[plugin]);
  });

  // Register pattern plugins
  Object.keys(patternPlugins).forEach((plugin) => {
    Vue.use(patternPlugins[plugin]);
  });

  installVeeValidate(Vue);
}

vueUse(install);

export default install;